import { render } from "./EmploymentPostView.vue?vue&type=template&id=1afbae5c"
import script from "./EmploymentPostView.vue?vue&type=script&lang=js"
export * from "./EmploymentPostView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__